import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useRole } from '@/hooks/useRole';
import { NO_ORG_REDIRECT_PATH, dashboardPathForRole } from '@/types/roles';
import { PageLoader } from '@/components/ui/loading-spinner';
import { isPasswordRecoveryFlowForUser } from '@/lib/authRecovery';

/**
 * Wraps auth pages (login, register, etc.).
 * Redirects already-authenticated users to their dashboard.
 */
export function RedirectIfLoggedIn() {
  const { role, isLoading, isAuthenticated, user } = useRole();
  const location = useLocation();

  if (
    location.pathname === '/reset-password' ||
    location.pathname === '/confirm-email' ||
    location.pathname === '/accept-invite' ||
    location.pathname === '/setup-mfa' ||
    location.pathname === '/verify-mfa'
  ) {
    return <Outlet />;
  }

  if (isLoading) {
    return <PageLoader />;
  }

  // Let unverified users stay on auth pages.
  if (isAuthenticated && user?.email_confirmed_at) {
    if (isPasswordRecoveryFlowForUser(user.id)) {
      return <Navigate to="/reset-password" replace />;
    }

    if (role) {
      return <Navigate to={dashboardPathForRole(role)} replace />;
    }
    return <Navigate to={NO_ORG_REDIRECT_PATH} replace />;
  }

  return <Outlet />;
}
